import {Point} from 'pixi.js';
import {Loc, Location} from '../../common/map/Location';
import {Projectile} from 'src/game/Projectile';
import {Game} from 'src/game/Game';

export class ProjectileRenderer {
    private projectiles: Map<string, Projectile> = new Map<string, Projectile>();

    public createProjectile(
        playerIndex: number,
        id: number,
        startAt: number,
        source: Loc,
        target: Loc
    ): void {
        const key = this.projectileKey(playerIndex, id);
        if (this.projectiles.has(key)) return;
        const sourcePoint = new Point(source.x, source.y);
        const targetPoint = new Point(target.x, target.y);
        const proj = new Projectile(sourcePoint, targetPoint, startAt);
        proj.start();
        this.projectiles.set(key, proj);
    }

    private projectileKey(playerIndex: number, id: number): string {
        return `${playerIndex}:${id}`;
    }

    public tick(game: Game): void {
        const toRemove: string[] = [];
        this.projectiles.forEach((projectile, key) => {
            if (!projectile.tick(game)) {
                toRemove.push(key);
                const source = Location.fromPoint(projectile.source).floored();
                const cannon = game.map.cannons.find(
                    cannon => cannon.x === source.x && cannon.y === source.y
                );
                if (cannon) {
                    cannon.projectile = undefined;
                }
            }
        });
        toRemove.forEach(key => this.projectiles.delete(key));
    }

    public clear(): void {
        this.projectiles.forEach(projectile => projectile.finish());
        this.projectiles.clear();
    }
}

export const projectileRenderer = new ProjectileRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/map/ProjectileRenderer.ts